<template>
  <div class="box">
    <div style="color: #1e398d">{{ title }}</div>
    <div class="separador"></div>
    <h3
      style="color: #0399cc"
      v-if="result || result === 0"
    >{{ result.toString() }}</h3>
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    result: {
      type: [String, Number, Boolean],
      default: 0,
    },
  },
};
</script>
<style scoped>
.box {
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 20px;
  justify-content: center;
  margin: 20px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 1px -2px,
    rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px;
  border-radius: 6px;
  max-width: 400px;
}
.box .separador {
  height: 1px;
  width: 90%;
  background: rgb(30, 57, 141);
  margin: 20px 0;
}
</style>
